import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Currently locked: ")
const _hoisted_5 = { class: "inline-block bg-yellow-200" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, "Creator: " + _toDisplayString(_ctx.vaultAcc.creator.toBase58()), 1),
    _createElementVNode("div", _hoisted_2, "Current owner: " + _toDisplayString(_ctx.vaultAcc.owner.toBase58()), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.vaultAcc.locked), 1)
    ]),
    _createElementVNode("div", _hoisted_6, "Mints stored: " + _toDisplayString(_ctx.vaultAcc.gemBoxCount), 1),
    _createElementVNode("div", _hoisted_7, "Gems stored: " + _toDisplayString(_ctx.vaultAcc.gemCount), 1)
  ]))
}